document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".infinite-slider[data-infinite='true']");

    sliders.forEach(slider => {
        const track = slider.querySelector("ul.product-grid"); // Updated selector
        if (!track) return;

        const slides = Array.from(track.children);

        // Prevent excessive cloning
        if (!slider.dataset.cloned) {
            slides.forEach(slide => {
                let clone = slide.cloneNode(true);
                track.appendChild(clone);
            });
            slider.dataset.cloned = "true";
        }

        let scrollAmount = 1; // Adjust speed if needed
        let isScrolling = true;

        function startScrolling() {
            if (!isScrolling) return;
            track.scrollLeft += scrollAmount;
            
            // Smooth infinite loop effect
            if (track.scrollLeft >= track.scrollWidth / 2) {
                track.scrollLeft -= track.scrollWidth / 4; // Instead of jumping, subtly reset
            }

            requestAnimationFrame(startScrolling);
        }

        slider.addEventListener("mouseenter", () => isScrolling = false);
        slider.addEventListener("mouseleave", () => {
            isScrolling = true;
            startScrolling();
        });

        startScrolling();
    });
});

